import { Box, Chip, Skeleton, Stack, Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../../features/AppState";
import {
  countCatalogueRows,
  selectDevObjectRows,
} from "./helpers/fetcherCatalogue";
import { FETCHER_BY_BRAND_TAB } from "./helpers/urlParams";
import Configs from "./Configs/Configs";
import Reports from "./Reports/Reports";
import Interfaces from "./Interfaces/Interfaces";
import BrandTrace from "./BrandTrace/BrandTrace";
import DevObjects from "./DevObjects/DevObjects";

export const FETCHER_TAB_KEYS = [
  "configs",
  "reports",
  "interfaces",
  FETCHER_BY_BRAND_TAB,
  "dev_objects",
];

const FetcherSettingsTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    fetcherSettingsMainTablesData,
    fetcherSettingsDevObjsData,
    isCatalogueLoading,
  } = useSelector((state: AppState) => state.fetcherSettings);

  const tabFromUrl = searchParams.get("tab") ?? "";
  const activeTab = FETCHER_TAB_KEYS.includes(tabFromUrl)
    ? FETCHER_TAB_KEYS.indexOf(tabFromUrl)
    : 0;

  const handleChange = (_: unknown, newValue: number) => {
    setSearchParams(
      () =>
        new URLSearchParams(
          newValue === 0 ? {} : { tab: FETCHER_TAB_KEYS[newValue] },
        ),
      { replace: true },
    );
  };
  const tabs = [
    {
      label: "Configs",
      count: countCatalogueRows(fetcherSettingsMainTablesData, "config"),
      trackerId: "1090",
    },
    {
      label: "Reports",
      count: countCatalogueRows(fetcherSettingsMainTablesData, "report"),
      trackerId: "1091",
    },
    {
      label: "Interfaces",
      count: countCatalogueRows(fetcherSettingsMainTablesData, "interface"),
      trackerId: "1092",
    },
    { label: "By Brand", count: null, trackerId: "1093" },
    {
      label: "Dev Objects",
      count: selectDevObjectRows(fetcherSettingsDevObjsData).length,
      trackerId: "1094",
    },
  ];

  const panels = [
    <Configs key="configs" />,
    <Reports key="reports" />,
    <Interfaces key="interfaces" />,
    <BrandTrace key="by_brand" />,
    <DevObjects key="dev_objects" />,
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="Fetcher Settings tabs"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.label}
              id={`fetcher-settings-tab-${index}`}
              aria-controls={`fetcher-settings-tabpanel-${index}`}
              data-tracker={tab.trackerId}
              label={
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <span>{tab.label}</span>
                  {tab.count !== null &&
                    (isCatalogueLoading ? (
                      <Skeleton
                        variant="rounded"
                        width={34}
                        height={24}
                        sx={{ borderRadius: "12px" }}
                      />
                    ) : (
                      <Chip size="small" label={tab.count} />
                    ))}
                </Stack>
              }
            />
          ))}
        </Tabs>
      </Box>

      <Box
        role="tabpanel"
        id={`fetcher-settings-tabpanel-${activeTab}`}
        aria-labelledby={`fetcher-settings-tab-${activeTab}`}
      >
        {panels[activeTab]}
      </Box>
    </Box>
  );
};

export default FetcherSettingsTabs;
